import { render, staticRenderFns } from "./SysMenu.vue?vue&type=template&id=8dfd0860"
import script from "./SysMenu.vue?vue&type=script&lang=js"
export * from "./SysMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports